export const displayName = (conversation) => {

    if (conversation?.is_call_chat && conversation?.display_name) {
        return conversation.display_name;
    }

    if (conversation?.group) {
        return conversation.group.name
    }
    if (conversation?.quick_chat) {
        return conversation.quick_chat_name
    }
    if (conversation?.meeting_name) {
        return conversation.meeting_name
    }

    let otherUser = conversation?.other_participants[0];
    let name = otherUser?.name;

    return name || "Unknown";
}